// src/modules/app-views/companies/pages/Init/components/tableColumns/cpfCnpjColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { parseCnpjToDisplay, parseCpfToDisplay, returnOnlyNumbers } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function cpfCnpjColumn(buildColumnProps, options = {}) {
  const {
    key = 'cpfCnpj',
    title = 'cpf_cnpj',
    dataIndex = 'uniqueKey',
    width = 180,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const isCompany = r?.entityType === 'company' || !!r?.cnpj?.value;
      const cpfValue = r?.cpf?.value;
      const cnpjValue = r?.cnpj?.value;

      if (isCompany && cnpjValue) {
        return parseCnpjToDisplay(returnOnlyNumbers(cnpjValue));
      }
      if (!isCompany && cpfValue) {
        return parseCpfToDisplay(returnOnlyNumbers(cpfValue));
      }
      return '—';
    },
  };
}

export default cpfCnpjColumn;
